<template>
  <div class="comment">
    <publish-comment :type="type" :source-id="sourceId" @call-back="setUpdateKey" ref="publish-comment"></publish-comment>
    <comment-list :type="type" :source-id="sourceId" :key="updateKey" :total-num="totalNum"></comment-list>
  </div>
</template>

<script>
import PublishComment from './PublishComment';
import CommentList from './CommentList';
export default {
    name: 'CommentIndex',
    components: {
        PublishComment,
        CommentList,
    },
    props: {
        type: { // 评论对象类型
            type: Number,
            required: true,
        },
        sourceId: { // 评论对象ID
            type: [Number, String],
            required: true,
        },
        totalNum: { // 评论总条数
            type: Number,
            required: false,
            default: () => 0,
        },
    },
    data: () => ({
        updateKey: '', // 手动触发更新
    }),
    mounted() {
        this.$nextTick(() => {
            this.$on('comment-focus', function() {
                this.$refs['publish-comment'].$emit('comment-focus'); 
            });
        });
    },
    methods: {
        // 手动触发更新
        setUpdateKey() {
            this.updateKey = Math.random();
        },
    }
}
</script>

<style lang="scss" scoped>
.comment {
    margin: 20px 0;
}
</style>
